"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _Pill = _interopRequireDefault(require("../Pill"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdiv {\n\t\tfont-size: 12px;\n\t\tletter-spacing: 0.05em;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Status = _styledComponents.default.span(_templateObject());

Status.displayName = 'StatusBadge';

var StatusBadge = function StatusBadge(_ref) {
  var statusType = _ref.statusType,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["statusType", "children"]);

  return _react.default.createElement(Status, props, _react.default.createElement(_Pill.default, {
    "data-testid": "pill",
    color: _colors.default[statusType],
    backgroundColor: _colors.default[statusType + "Background"]
  }, children));
};

StatusBadge.defaultProps = {
  statusType: 'neutral'
};
StatusBadge.propTypes = {
  statusType: _propTypes.string,
  children: _propTypes.node.isRequired
};
var _default = StatusBadge;
exports.default = _default;